import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HelpService {
  public disabled = false;
}
